import React from 'react'

import {
  AlignItems,
  Box,
  Col,
  Display,
  FlexDirection,
  FontWeight,
  Grid,
  JustifyContent,
  Space,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'
import { DEFAULT_BOXES } from '../config'
import type { DiscountBox } from '../config'

type DiscountPerWeekProps = {
  boxes?: DiscountBox[]
}

export const DiscountPerWeek = ({ boxes = DEFAULT_BOXES }: DiscountPerWeekProps) => {
  return (
    <Box data-testid="discount-per-week" display={Display.Flex} width="100%">
      <Grid
        width="100%"
        columnGap={[2, 4]}
        gridTemplateColumns={[
          `repeat(${boxes.length}, minmax(0, 1fr))`,
          `repeat(${boxes.length}, max-content)`,
        ]}
      >
        {boxes.map((box) => (
          <Col key={box.label} size={1}>
            <Box
              display={Display.Flex}
              alignItems={AlignItems.Center}
              flexDirection={FlexDirection.Column}
            >
              <Box
                bg={box.bgColor}
                borderRadius={1.5}
                width={['100%', '90px']}
                minWidth={['72px', '90px']}
                height={['50px', '52px']}
                display={Display.Flex}
                alignItems={AlignItems.Center}
                justifyContent={JustifyContent.Center}
                paddingH={[2, 2]}
              >
                <Box
                  display={Display.Flex}
                  flexDirection={FlexDirection.Column}
                  alignItems={AlignItems.Center}
                  justifyContent={JustifyContent.Center}
                  style={{ lineHeight: 1 }}
                >
                  <Text
                    size={[4, 5]}
                    color={box.textColor}
                    fontWeight={FontWeight.Bold}
                    textAlign={TextAlign.Center}
                  >
                    {box.discountValue}
                  </Text>
                  <Text
                    size={[1, 2, 3]}
                    color={box.textColor}
                    fontWeight={FontWeight.Bold}
                    textAlign={TextAlign.Center}
                  >
                    {box.discountSuffix}
                  </Text>
                </Box>
              </Box>

              <Space size={2} />

              <Text
                size={[0, 1, 2]}
                color={box.textColor}
                textAlign={TextAlign.Center}
                style={{ whiteSpace: 'nowrap' }}
              >
                {box.label}
              </Text>
            </Box>
          </Col>
        ))}
      </Grid>
    </Box>
  )
}
